import { render } from "./HeroiconsOutlineBeaker.vue?vue&type=template&id=253db58e"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineBeaker.vue"]])

export default __exports__